import { Component, NgModule, Input } from '@angular/core';
import { SharedService } from "./shared.service";
import { MeetingDisplayItem } from "./model/model.class";
import { User, WorkloadTable, Week, UserFeatures, Parameters, SectionType } from './model/model.class';
import { Labels } from './model/language.model.class';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'wlt-component',
  templateUrl: './wlt.component.html',
  styleUrls: ['./wlt.component.css']
})

export class WltComponent {

  @Input() accounId: string;
  @Input() user: User;
  @Input() labels: Labels;

  workloadTable: WorkloadTable;
  weekId = "";
  weeks: Week[];

  public userFeatures;

  constructor(private sharedService: SharedService, private sanitizer: DomSanitizer) {
    this.sharedService.workloadEvent.subscribe(data => {
      this.weeks = data.Weeks.filter(week => week.Days.length > 1);
      this.workloadTable = data;
      
      setTimeout(() => {
        let result = this.getWeekAndDayNumberFromWorkloadTable(new Date());
        if (result) {
          const firstDayOfWeek = this.getFirstDayOfWeekFromWorkloadTable(result.weekno);
          if (firstDayOfWeek !== null && firstDayOfWeek == 1) {
            // first day of week is sunday, but on the client the week is always built considering the first day as monday: it is needed an adjustment
            result.dayno = result.dayno - 1;
          }
          this.scroll("target-week-" + result.weekno, result.dayno);
        }
      });

    });

    this.sharedService.userEvent.subscribe(data => {
      this.workloadTable = undefined;
    });
  }


  ngOnInit() {
    /*this.sharedService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });*/
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if(currentUser && currentUser.userTypes && currentUser.userTypes.length > 0) {
      this.userFeatures = this.sharedService.getTextualFunctionality(currentUser);
    }
  }

  private OpenTab(tabView) {
    this.sharedService.SwitchTab(tabView);
  }


  private FormatDate(date, dayNumber) {
    var d = new Date(date);
    return this.labels['Days'][dayNumber] + ' ' + d.toLocaleDateString();
  }

  /**
   * Scrolls the tourplan visualization in order that it is aligned to the left to
   * the given element (if the dayno is provided it aligns to the given day)
   * @param elementId: the elementId corresponding to the beginnig of the week
   * @param dayno: the day number to which we want to align the week display
   */
  private scroll(elementId, dayno = 0) {
    const scroller = document.getElementById('scroller');
    const el = document.getElementById(elementId);

    if (el && el.getBoundingClientRect() && el.getBoundingClientRect().left != 0) {
      const clientrec = el.getBoundingClientRect();
      const dx = clientrec.left + clientrec.width * dayno;

      // -240 is a workaround to align on the left to the first day of the week
      scroller.scrollLeft = scroller.scrollLeft + dx - 240;
    }
  }

  private setId(value, day) {
    if (this.weekId != value && day > 1) {
      this.weekId = value;
      return true;
    }
    return false;
  }

  private onScroll(event) {
    var bt = undefined;
    var targetWidth = event.target.getBoundingClientRect().width;
    var childWidth = event.target.firstElementChild.clientWidth;
    var left = targetWidth > childWidth * 2 ? childWidth / 2 + childWidth : targetWidth / 2;
    do {
      var id = document.elementFromPoint(left, event.target.getBoundingClientRect().top + 10).getAttribute("btn-id");
      bt = document.getElementById(id);
      var delta = targetWidth > childWidth ? childWidth : targetWidth / 2;
      left = left - delta;
      if (left < 0) break;
    } while (bt == undefined);

    var bts = document.getElementsByClassName("week-selected");
    for (var i = 0; i < bts.length; i++) {
      bts[i].classList.remove("week-selected")
    }

    if (bt != undefined)
      bt.classList.add("week-selected");
  }

  /**
   * Calculates the week number and the day number inside the week for the given date, as stated by the workload table calculated by the server.
   * Returns an object {weekno, dayno} with the calculated values; it returns null if the current workload table does not contain the given date.
   * @param d: a date
   */
  private getWeekAndDayNumberFromWorkloadTable(d: Date): any {
    const wlt = this.workloadTable;
    for (const week of wlt.Weeks) {
      let j = 0;
      for (const day of week.Days) {
        if (this.sameDay(d, day.Day)) {
          let w = week.WeekNumber;
          return {weekno: w, dayno: j};
        }
        j++;
      }
    }
    return null;
  }

  /**
   * Returns the first day of the week from the workload table for the given week number.
   * 1 is Sunday, 2 is Monday, ..., 7 is Saturday.
   * @param weekno; the week number
   */
  private getFirstDayOfWeekFromWorkloadTable(weekno: number): number {
    const wlt = this.workloadTable;
    for (const week of wlt.Weeks) {
      if (week.WeekNumber !== weekno) continue;
      if (week.Days.length > 0) {
        return week.Days[0].DayOfWeek;
      }
    }
    return null;
  }



  private sameDay(date1: Date, date2: string): boolean {
    const day1 = date1.getFullYear() + '-' + this.pad(date1.getMonth() + 1, 2) + '-' + this.pad(date1.getDate(), 2);
    const day2 = date2.substr(0, 10);
    return day1 === day2;
  }

  private pad(n: number, length: number): string {
    let result = String(n);
    while (result.length < length) { result = "0" + result; }
    return result;
  }

  private getWeekNumber(d) {
    let target: any = new Date(d.valueOf());
    // ISO week date weeks start on monday  
    // so correct the day number  
    let dayNr = (d.getDay() + 6) % 7;
    // Set the target to the thursday of this week so the  
    // target date is in the right year  
    target.setDate(target.getDate() - dayNr + 3);
    // ISO 8601 states that week 1 is the week  
    // with january 4th in it  
    let jan4: any = new Date(target.getFullYear(), 0, 4);
    // Number of days between target date and january 4th  
    let dayDiff = (target - jan4) / 86400000;
    // Calculate week number: Week 1 (january 4th) plus the    
    // number of weeks between target date and january 4th    
    let weekNr = 1 + Math.ceil(dayDiff / 7);

    return weekNr;
  }

  public checkIfDateIsInThePast(dateOfWeek) {
    var dateOfWeekObj = new Date(dateOfWeek);
    var now = new Date();
    now.setHours(0, 0, 0, 0);

    if (dateOfWeekObj < now) {
      return true;
    } else {
      return false;
    }
  }

  public getMeetingItem(visit: any): MeetingDisplayItem {
    const showReport = visit.Outcomes != null && visit.Outcomes.length > 0;
    let outcome = "";

    if (showReport) {
      outcome = Array.from(visit.Outcomes as Array<string>, (o: string) => this.labels.Outcome[o]).join(",");
    }

    let meetingItem: MeetingDisplayItem = {
      name1: visit.Name1,
      name2: visit.Name2,
      customerId: visit.CustomerId,
      origin: visit.Origin,
      eventType: visit.EventType,
      isPhoneCall: visit.IsPhoneCall,
      visitRule: visit.VisitRule,
      outcome: outcome,
      icon_on_top_left: '',
      icon_on_bottom_left: '',
      fixedStartDate: visit.FixedStartDate,
      duration: visit.Duration,
      customerState: visit.CustomerState,
      priority: visit.Priority
    };

    return this.sharedService.getMeetingPointPopup(meetingItem);
  }

}



// WEBPACK FOOTER //
// ./src/app/wlt.component.ts